import React, {
  useCallback,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import DynamicSearchWithDropdown from '../common/inputs/DynamicSearchWithDropdown';

import BoardSearchDropdownItem from './BoardSearchDropdownItem';

import {
  setBoardTargetCard, openCardDrawer, openFormMapDrawer, openShortListDrawer,
} from './state/boards.actions';

function BoardSearchDropdown({
  onBoardSelect,
  onCardSelect,
  deepSearchCards,
  deepSearchText,
  setDeepSearchCards,
  setDeepSearchText,
  loading,
}) {
  const dispatch = useDispatch();

  const allCards = useSelector((state) => state.boards.fullCards);

  const onCardClick = useCallback(async ({
    id: cardId,
    boardId,
    statusId,
  } = {}) => {
    if (!boardId) return Promise.resolve(false);
    return new Promise((resolve) => {
      setTimeout(() => {
        onBoardSelect(boardId);
        dispatch(setBoardTargetCard({ cardId, statusId, boardId }));
        resolve(true);
      }, 250);
    });
  }, [onBoardSelect]);

  const onForm = useCallback((cardId) => {
    dispatch(openFormMapDrawer({
      selectedCardId: cardId,
    }));
  }, [dispatch, allCards]);

  const onShortList = useCallback((cardId) => {
    dispatch(openShortListDrawer({
      selectedCardId: cardId,
    }));
  }, [allCards]);

  const onViewClicked = useCallback(async (card) => {
    if (!card) return false;
    dispatch(openCardDrawer({ selectedCardId: card.id, onForm, onShortList }));
    onCardSelect(card);
    return true;
  }, [dispatch, onForm, onShortList, onCardSelect]);

  return (
    <DynamicSearchWithDropdown
      path="/boards/search"
      onItemClick={onCardClick}
      Item={BoardSearchDropdownItem}
      mainItemSearchKey="title"
      overrideData={deepSearchCards}
      overrideSearchTerm={deepSearchText}
      setOverrideData={setDeepSearchCards}
      setOverrideSearchTerm={setDeepSearchText}
      onViewClicked={onViewClicked}
      loading={loading}
    />
  );
}

/* eslint-disable react/forbid-prop-types */
BoardSearchDropdown.propTypes = {
  onBoardSelect: PropTypes.func.isRequired,
  onCardSelect: PropTypes.func.isRequired,
  deepSearchCards: PropTypes.array,
  deepSearchText: PropTypes.string,
  setDeepSearchCards: PropTypes.func.isRequired,
  setDeepSearchText: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

BoardSearchDropdown.defaultProps = {
  deepSearchCards: null,
  deepSearchText: null,
  loading: false,
};

export default BoardSearchDropdown;
